<template>
  <div>
    <div class="w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px" :style="`background-color: ${mainColor};`">
      <router-link :to="{ name: 'UserInfo' }">
        <svg-filler class="mg-r-auto f-left cs-pointer" path="/static/svg/back.svg" :fill="'#ffffff'" width="20px" height="20px"/>
      </router-link>
      <span>
        รายงานสรุปยอดประจำวัน
      </span>
    </div>
    <div class="columns is-centered is-marginless">
      <div class="h-60calc mg-t-16px pd-hrzt-35px column is-4">
        <div class="dp-flex jtf-ct-space-between ">
          <div class="f-left f-s-14px f-w-bold">เลือกวันที่</div>
          <div class="f-right w-62pct">
              <b-datepicker placeholder="เลือกวันที่ ที่ต้องการพิมพ์" icon="calendar-today" v-model="selectedDate" :max-date="maxDate" />
          </div>
        </div>
        <div class="dp-flex jtf-ct-space-between mg-t-16px">
          <div class="f-left f-s-14px f-w-bold">เงินตั้งต้น</div>
          <div class="f-right w-62pct">
              <b-input v-model="startPrice" type="number" min="0"></b-input>
          </div>
        </div>
        <div class="dp-flex jtf-ct-space-between mg-t-16px">
          <div class="f-left f-s-14px f-w-bold">ยอดงานนำส่ง</div>
          <div class="f-right w-62pct">
              <b-input v-model="givePrice" type="number" min="0"></b-input>
          </div>
        </div>
        <div class="dp-flex jtf-ct-space-between mg-t-16px">
          <div class="f-left f-s-14px f-w-bold">เครื่องปริ้น</div>
          <div class="f-right w-62pct">
            <b-select expanded placeholder="เลือก Printer" v-model="selectedPrinter">
              <option :value="printer.ip" v-for="(printer, index) in printers" :key="index">{{printer.name}}</option>
            </b-select>
          </div>
        </div>
        <div class="columns is-marginless">
          <div class="disabled mg-auto pd-vtc-5px pd-hrzt-2px mg-t-16px"  v-if="(((startPrice === '' || startPrice === '0') || (givePrice === '' || givePrice === '0')) || selectedPrinter === '' )"> พิมพ์รายงาน </div>
          <div @click="print()" class="print-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px mg-t-16px" :style="`background-color: ${mainColor};`"  v-else> พิมพ์รายงาน </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentBranchPOS } from '@/utils/helper/localStorage'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'

import ReportProvider from '@/resources/report_provider'
import PrintProvider from '@/resources/print_provider'
const reportProvider = new ReportProvider()

const printService = new PrintProvider()
export default {
  name: 'ReportZ',
  data () {
    return {
      maxDate: new Date(),
      selectedDate: new Date(),
      selectedPrinter: '',
      startPrice: '',
      givePrice: ''
    }
  },
  computed: {
    ...mapGetters({
      printers: 'getPrinters',
      storeId: 'storeId',
      mainColor: 'mainColor'
    })
  },
  methods: {
    ...mapActions([
      'fetchPrinters',
      'setReceiptData',
      'setIsloading',
      'triggerPrinter'
    ]),
    back () {
      this.$router.push({path: '/user-info'})
    },
    async print () {
      this.setIsloading(true)
      if (this.validateData()) {
        this.setIsloading(false)
        this.$dialog.alert({
          title: 'เกิดข้อผิดพลาด',
          confirmText: 'ตกลง',
          message: 'มีบางอย่างผิดพลาดกรุณากรอกข้อมูลให้ครบ'
        })
        return
      }
      const formatSelectedDate = moment(this.selectedDate).subtract(1, 'days').format('YYYY-MM-D')
      const reportZ = await reportProvider.getReportZ(formatSelectedDate)
      const currentBranchPOS = getCurrentBranchPOS()
      const payload = {
        sumBillNet: parseFloat(reportZ.sum_bill_net),
        sumBillDiscount: parseFloat(reportZ.sum_bill_discount),
        startPrice: parseFloat(this.startPrice),
        givePrice: parseFloat(this.givePrice),
        countBill: parseInt(reportZ.count_bill),
        firstBill: reportZ.first_bill[0] ? reportZ.first_bill[0] : null,
        lastBill: reportZ.last_bill[0] ? reportZ.last_bill[0] : null,
        displayTime: moment().format('DD-MM-YYYY HH:mm'),
        printTime: moment().format('DD-MM-YYYY HH:mm'),
        storeDisplayName: 'Gentlewoman',
        payments: reportZ.payment.map(re => ({
          total: parseFloat(re.total),
          type: re.payment_channel === 'Cash' || re.payment_channel === 'cash' ? 'cash' : 'credit'
        })),
        print: {
          message: '',
          status: 'pending',
          ip: this.selectedPrinter
        },
        branchPos: {
          branchId: parseInt(currentBranchPOS.branch_id),
          name: currentBranchPOS.name,
          posId: currentBranchPOS.pos_id,
          taxId: 'TAX#0-1055-61034-56-1',
          unitId: parseInt(currentBranchPOS.unit_id),
          code: currentBranchPOS.warehouse
        }
      }
      try {
        await printService.printReportZ(payload)
      } catch (err) {
        console.log(err)
        alert('ไม่พบรายงานการขาย')
      }
      this.setIsloading(false)
    },
    validateData () {
      return this.selectedPrinter === '' || this.startPrice === '' || this.givePrice === ''
    }
  },
  async mounted () {
    await this.fetchPrinters()
  }
}
</script>

<style scoped>
.print-btn {
  width: 210px;
  height: 36px;
  border-radius: 4px;
  background-color: #1b0000;
  border: solid 0.5px #e5e5e5;
  color:white;
}
.disabled {
  width: 210px;
  height: 36px;
  border-radius: 4px;
  background-color: #1b00009c;
  border: solid 0.5px #e5e5e5;
  color:white;
}
</style>



// WEBPACK FOOTER //
// src/views/report/ReportZ.vue